<template>
  <div class="video-play">
    <section class="section">
      <div class="section__wrapper video-play__wrapper">
        <div class="video-play__wrapper--inner">
          <video 
            ref="videoEl"
            v-if="returnedVideo" 
            :id="`video-${returnedVideo.id}`"
            controls="true"
            preload="auto"
            class="video-play__video"
            @ended="showCredits"
            @timeupdate="checkVideoCompletion"
          >
            <source :src="returnedVideo.url" type="video/mp4">
          </video>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="section__wrapper mt-4">
        <div class="video-play__options-bar">
          <div class="video-play__options--left">
            <router-link :to="{ name: 'view-home' }">
              <img class="video-play__home-link" src="../assets/BTAB_one_line.svg" alt="Britain Take A Bow">
            </router-link>
          </div>
          <div class="video-play__options--right">
            <button class="button video-play__button" @click="reload">Load a new version</button>
            <p class="video-play__link video-play__credits-link" @click="showCredits">Credits</p>
          </div>
        </div>
      </div>
    </section>
    <credits 
      :displayCredits="displayCredits"
      :creditData="creditData"
      :reload="reload"
      :hideCredits="hideCredits"
      :replayVideo="replayVideo"
      :typoCredit="typographyCredit"
    />
  </div>
</template>

<script>
import * as APIService from '../services/api';
import Credits from '../components/Credits';

export default {
  name: 'video-play',
  data() {
    return {
      returnedVideo: false,
      viewRecorded: false,
      viewRecordSent: false,
      videoViewThreshold: 0.5,
      displayCredits: false,
    };
  },
  computed: {
    videoLength() {
      if (this.returnedVideo) {
        return this.$refs.videoEl.duration;
      }
      return false;
    },
    creditData() {
      if (this.returnedVideo) {
        return this.returnedVideo.credits.data;
      }
      return [];
    },
    typographyCredit() {
      if (this.returnedVideo && this.returnedVideo.typoCredit) {
        return this.returnedVideo.typoCredit;
      }
      return false;
    },
  },
  methods: {
    getVideoToPlay() {
      APIService.GetVideoToPlay().then((res) => {
        this.returnedVideo = res.data;
      });
    },
    recordVideoView() {
      if (!this.viewRecorded) {
        APIService.MarkVideoAsWatched(this.returnedVideo.id).then((res) => {
          if (res.ok) {
            this.viewRecorded = true;
          } else {
            this.viewRecordSent = false;
          }
        })
        .catch(() => {
          this.viewRecordSent = false;
        });
      }
    },
    reload() {
      this.displayCredits = false;
      this.returnedVideo = false;
      this.viewRecorded = false;
      this.viewRecordSent = false;
      this.$nextTick(() => {
        this.getVideoToPlay();
      });
    },
    checkVideoCompletion() {
      if (this.$refs.videoEl) {
        const videoCurrentTime = this.$refs.videoEl.currentTime;
        if (!this.viewRecorded &&
        !this.viewRecordSent &&
        (videoCurrentTime / this.videoLength) > this.videoViewThreshold) {
          this.recordVideoView();
          this.viewRecordSent = true;
        }
      }
    },
    showCredits() {
      this.displayCredits = true;
      this.$refs.videoEl.pause();
    },
    hideCredits() {
      this.displayCredits = false;
      if (!this.viewRecordSent) {
        this.$refs.videoEl.play();
      }
    },
    replayVideo() {
      this.displayCredits = false;
      this.$refs.videoEl.currentTime = 0;
      this.$refs.videoEl.play();
    },
  },
  mounted() {
    this.getVideoToPlay();
  },
  components: {
    Credits,
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// video-play.vue?540f8cea